import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Layout, Steps, Button, message, Row, Col } from "antd";
import LaborRates from "../../containers/labor-rates/LaborRates";
import OptionSetup from "../../containers/option-setup/OptionSetup";
import ManagerSteps from "./ManagerSteps";
import useActiveProject from "../../utils/useActiveProject";
import useSyncProjectData from "../../utils/useSyncProjectData";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
const { Content } = Layout;

const ManagerOptionSetup: React.FC = () => {
  useActiveProject();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, []);
  const { id } = useParams<any>();
  const [isLoading] = useSyncProjectData(id);
  return (
    <>
      {isLoading === true ? (
        <Row style={{ padding: "80px 0px" }} justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Content>
          <ManagerSteps current={3} />
          <div className="steps-content">
            <Row>
              <Col className="gutter-row" span={24}>
                <OptionSetup manager={true} />
              </Col>
            </Row>
          </div>
        </Content>
      )}
    </>
  );
};

export default ManagerOptionSetup;
